export const blockIconsTextformattingContactPageNew = (
	<span className='material-symbols-outlined'>contact_page</span>
);
